export function updateClassNames(
  classNames: string,
  className: string,
  shouldAddClass: boolean,
) {
  const currentClasses = classNames.split(" ");
  const hasHighlightClass = currentClasses.includes(className);

  if (shouldAddClass && !hasHighlightClass) {
    currentClasses.push("highlight");
  } else if (!shouldAddClass && hasHighlightClass) {
    return currentClasses.filter((cls) => cls !== className).join(" ");
  }

  return currentClasses.join(" ");
}
